<i class="pi pi-exclamation-triangle" (click)="scrollToErrorContainer()"></i>
